// --- FilterContext ----
// On utilise le Context API natif de React pour faire descendre les datas
// sur tout l'arbre de composant
// Ex: import FilterContext from '/contexts';

import {createContext} from 'react';
import I_STATE from './I_STATE';
import INITIAL_STATE from './INITIAL_STATE';
import reducer from './reducer';
import REDUCER_ACTIONS from './ACTIONS';

interface I_CONTEXT {
  state: I_STATE;
  dispatch: any;
}

const INITIAL_CONTEXT:I_CONTEXT = {
  state: INITIAL_STATE,
  dispatch: undefined,
};

const FilterContext = createContext(INITIAL_CONTEXT);

export default FilterContext;

const filtersReducer = reducer;
const FILTERS_REDUCER_ACTIONS = REDUCER_ACTIONS;
const FILTERS_INITIAL_STATE = INITIAL_STATE;
export {filtersReducer,FILTERS_REDUCER_ACTIONS,FILTERS_INITIAL_STATE};
